/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
// @mui material components

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";
import { useMaterialUIController, setErrorSB } from "context";
import useLocale from "context/useLocale";
import { useState, useEffect } from "react";
import Moment from "react-moment";

import { fetchAll } from "services/VehicleRequests";

export default function data() {
  const locale = useLocale();
  const [, dispatch] = useMaterialUIController();
  const [rows, setRows] = useState([]);
  const [paginationMeta, setPaginationMeta] = useState({});

  const loadData = (page) => {
    fetchAll(page).then(
      (res) => {
        setRows(res.data.data.data);
        setPaginationMeta(res.data.data.meta.pagination);
      },
      (err) => setErrorSB(dispatch, `${err.response.data.error.message}`)(err)
    );
  };

  useEffect(() => {
    loadData(1);
  }, []);

  const renderRows = rows.map((row) => {
    const vehicleData = row.vehicle_data;

    // Helper function to render vehicle title with appropriate link
    const renderVehicleTitle = () => {
      if (!vehicleData) return "N/A";

      if (vehicleData.type === "vehicle_entry") {
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${process.env.REACT_APP_WEBSITE_URL}/buy/used/entry/${vehicleData.id}`}
            style={{ color: "inherit", fontWeight: "bold" }}
          >
            {vehicleData.vehicle_model.brand.title} {vehicleData.vehicle_model.title} (Entry)
          </a>
        );
      }
      if (vehicleData.type === "vehicle_variant") {
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${process.env.REACT_APP_WEBSITE_URL}/buy/new/variant/${vehicleData.vehicle_model?.vehicle_type?.code}/${vehicleData.vehicle_model?.vehicle_category?.code}/${vehicleData.vehicle_model?.brand?.id}/${vehicleData.vehicle_model?.id}/${vehicleData.id}/${vehicleData.year}`}
            style={{ color: "inherit", fontWeight: "bold" }}
          >
            {vehicleData.title} (Variant)
          </a>
        );
      }
      return "N/A";
    };

    // Helper function to render category
    const renderCategory = () => {
      if (!vehicleData?.vehicle_model?.vehicle_category) return "N/A";

      return (
        <MDTypography variant="" color="text" fontWeight="medium">
          {vehicleData.vehicle_model.vehicle_category.title}
        </MDTypography>
      );
    };

    // Helper function to render brand
    const renderBrand = () => {
      const brand = vehicleData?.vehicle_model?.brand;
      if (!brand) return "N/A";

      return (
        <MDTypography variant="" color="text" fontWeight="medium">
          {brand.title}
        </MDTypography>
      );
    };

    // Helper function to render model
    const renderModel = () => {
      if (!vehicleData?.vehicle_model) return "N/A";

      return (
        <MDTypography variant="" color="text" fontWeight="medium">
          {vehicleData.vehicle_model.title}
        </MDTypography>
      );
    };

    return {
      id: row.id,
      name: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.name}
        </MDTypography>
      ),
      phone: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.phone}
        </MDTypography>
      ),
      source: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.source}
        </MDTypography>
      ),
      // email: (
      //   <MDTypography component="p" variant="button" color="text" fontWeight="medium">
      //     {row.email}
      //   </MDTypography>
      // ),
      vehicle: renderVehicleTitle(),
      year: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.vehicle_data.year || row.vehicle_data.vehicle_variant.year}
        </MDTypography>
      ),
      category: renderCategory(),
      brand: renderBrand(),
      model: renderModel(),
      region: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.region.name}-{row.region.city.name}
        </MDTypography>
      ),
      cash: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.cash}
        </MDTypography>
      ),
      comment: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.comment}
        </MDTypography>
      ),
      fleet: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.fleet}
        </MDTypography>
      ),
      fleet_name: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.fleet_name}
        </MDTypography>
      ),
      number_of_cars: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {row.number_of_cars}
        </MDTypography>
      ),
      created_at: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          <Moment format="DD-MMM-YYYY, hh:mm A">{row.created_at}</Moment>
        </MDTypography>
      ),
    };
  });

  return {
    columns: [
      { Header: locale("id"), accessor: "id" },
      { Header: locale("name"), accessor: "name" },
      { Header: locale("phone"), accessor: "phone" },
      { Header: locale("source"), accessor: "source" },
      // { Header: locale("email"), accessor: "email" },
      { Header: locale("vehicle"), accessor: "vehicle" },
      { Header: locale("year"), accessor: "year" },
      { Header: locale("truck_category"), accessor: "category" },
      { Header: locale("brand"), accessor: "brand" },
      { Header: locale("model"), accessor: "model" },
      { Header: locale("region"), accessor: "region" },
      { Header: locale("cash"), accessor: "cash" },
      { Header: locale("comment"), accessor: "comment" },
      { Header: locale("fleet"), accessor: "fleet" },
      { Header: locale("fleetName"), accessor: "fleet_name" },
      { Header: locale("numberOfCars"), accessor: "number_of_cars" },
      { Header: locale("createdAt"), accessor: "created_at" },
    ],
    rows: renderRows,
    paginationMeta,
    loadData,
  };
}
